import { Component, h, State } from '@stencil/core';
import { isUserLoggedIn } from '../../utils/is_user_logged_in';

@Component({
  tag: 'ci-navigation-rightside',
  styleUrl: 'ci-navigation-rightside.scss',
  assetsDirs: ['.../assets'],
})
export class DefaultHeader {
  @State() isAccountHovered: boolean = false;

  // Declare the properties here
  private hideAccountTimeout: number;

  render() {

    const onAccountsHover = () => {
      clearTimeout(this.hideAccountTimeout);
      if (!this.isAccountHovered) {
        this.isAccountHovered = true;
        const elAccountsMenus = Array.from(document.getElementsByClassName('ciHeader-account-subMenu'));
        const elAccountsBtns = Array.from(document.getElementsByClassName('ciHeader-accounts-btn'));
        // show sub menu
        elAccountsMenus.forEach(el => el.classList.add('ciHeader-account-subMenu--isActive'));
        elAccountsBtns.forEach(el => el.classList.add('ciHeader-accounts-btn--isActive'));
      }
    };

    const onAccountsLeave = () => {
      this.hideAccountTimeout = window.setTimeout(() => {
        this.isAccountHovered = false;
        const elAccountsMenus = Array.from(document.getElementsByClassName('ciHeader-account-subMenu'));
        const elAccountsBtns = Array.from(document.getElementsByClassName('ciHeader-accounts-btn'));
        elAccountsMenus.forEach(el => el.classList.remove('ciHeader-account-subMenu--isActive'));
        elAccountsBtns.forEach(el => el.classList.remove('ciHeader-accounts-btn--isActive'));
      }, 200);
    };


    return (
      <div class="ciHeader-main-actions">

        <div class="ciHeader-accounts" onMouseEnter={() => onAccountsHover()} onMouseLeave={() => onAccountsLeave()}>
          <ci-button variant="text" href={`${process.env.CI_HOSTNAME}/profiles/retrieve`} styles="ciHeader-accounts-btn" class="js-ciHeader-track"
          data-section="my account"
          data-link="my account">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5ZM8 16.5C6.34315 16.5 5 17.8431 5 19.5V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19.5C3 16.7386 5.23858 14.5 8 14.5H16C18.7614 14.5 21 16.7386 21 19.5V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19.5C19 17.8431 17.6569 16.5 16 16.5H8ZM12 11C13.933 11 15.5 9.433 15.5 7.5C15.5 5.567 13.933 4 12 4C10.067 4 8.5 5.567 8.5 7.5C8.5 9.433 10.067 11 12 11Z" fill="#4A4A4A"/>
            </svg>
            {isUserLoggedIn() ? 'My Account' : 'Log In'}
          </ci-button>
          <ci-accounts></ci-accounts>
        </div>

        <ci-cart class="js-ciHeader-track"
        data-section="my cart"
        data-link="my cart"></ci-cart>
      </div>
    );
  }
}
